module.exports = __webpack_public_path__ + "img/mg.30a3e51a.svg";